import type { DocMigration } from "../docMigration";

/**
 * This is a duplicate of the 20260209_remove_room_block_id migration, as it was discovered that
 * more instances of blockId set on rooms were being added after the original migration was applied.
 */
const migration: DocMigration = {
  id: "20260303_remove_room_block_id",
  description: "Remove blockId from rooms in favor of parentId",
  apply(json: any): any {
    const rooms: Record<string, any> = json.rooms ?? {};
    for (const room of Object.values(rooms)) {
      if (room.blockId && room.parentId && room.blockId !== room.parentId) {
        room.parentId = room.blockId;
      }

      if (room.blockId && !room.parentId) {
        room.parentId = room.blockId;
      }

      delete room.blockId;
    }
    return json;
  },
};

export default migration;
